import React from 'react';
import SearchStandard from './SearchStandard';

const Search = () => {
  return <React.Fragment />;
};

Search.Standard = SearchStandard;
export default Search;
